<template>
  <div class="mt-5">
    <h4>ราคาคอร์สและระยะเวลาเรียน</h4>
    <div class="management-section">
      <div class="title-section">
        <span>รูปแบบคอร์สเรียนออนไลน์</span>
        <b-button variant="primary" @click="toggleModal()">
          จัดการ
        </b-button>
      </div>
      <div class="duration-section">
        <b-row>
          <b-col cols="5"><p>ระยะเวลาเรียน :</p></b-col>
          <b-col cols="7">
            <p v-if="courseInfo.learnDuration">
              {{ courseInfo.learnDuration | formatNumber }} วัน
            </p>
            <p v-else>-</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5"><p>ราคาคอร์ส :</p></b-col>
          <b-col cols="7">
            <p>ฟรี</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5"><p>จำนวนชั่วโมงที่ให้ทดลองเรียน :</p></b-col>
          <b-col cols="7">
            <p v-if="courseInfo.learnTimeLimit">
              {{ courseInfo.learnTimeLimit | formatNumber }} ชั่วโมง
            </p>
            <p v-else>ไม่จำกัดชั่วโมงเรียน</p>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal
      id="online-course-price-modal"
      v-model="showTrialCourseModal"
      title="ราคาคอร์สและระยะเวลาเรียนออนไลน์"
      size="lg"
      centered
      hide-footer
    >
      <div>
        <p>ราคา: ฟรี <span class="trial-badge">ทดลองเรียน</span></p>
        <b-row class="mt-4">
          <b-col cols="6">
            <b-form-group label="ระยะเวลาเรียน *">
              <b-input-group append="วัน">
                <b-form-input
                  v-model="form.learnDuration"
                  placeholder="ไม่จำกัด"
                  :formatter="formatNumberInput"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="จำนวนชั่วโมงที่ให้ทดลองเรียน">
              <b-input-group append="ชั่วโมง">
                <b-form-input
                  v-model="form.learnTimeLimit"
                  placeholder="ไม่จำกัด"
                  :formatter="formatNumberInput"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="12" class="text-right">
            <b-button variant="primary" @click="submit()">บันทึก</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Numeral from "numeral";

export default {
  filters: {
    formatNumber: function(value) {
      return Numeral(value).format("0,00");
    },
  },
  computed: {
    ...mapGetters("CourseManagement", ["courseInfo"]),
  },
  data() {
    return {
      courseId: this.$route.params.courseId,
      showTrialCourseModal: false,
      form: {
        learnDuration: null,
        learnTimeLimit: null,
      },
    };
  },
  methods: {
    ...mapActions("CourseManagement", ["getCourseInfo", "updateCourseInfo"]),
    async submit() {
      const cleanNumber = (val, fallback = null) => {
        if (val === null || val === undefined || val === "") return fallback;
        const sanitized = String(val).replace(/,/g, "");
        const num = Number(sanitized);
        return isNaN(num) ? fallback : num;
      };

      const numberFields = ["learnDuration", "learnTimeLimit"];

      let params = numberFields.reduce((acc, key) => {
        acc[key] = cleanNumber(this.form[key], null);
        return acc;
      }, {});

      await this.updateCourseInfo({
        courseId: this.courseId,
        attribute: params,
      });
      this.toggleModal();
    },
    async toggleModal() {
      await this.getCourseInfo({
        courseId: this.courseId,
        temp: true,
        excepts: "numberOfStudent,numberOfActiveStudent",
      });
      this.showTrialCourseModal = !this.showTrialCourseModal;
    },
    formatNumberInput(value) {
      const clean = value.replace(/[^0-9]/g, "");
      return clean ? Numeral(clean).format("0,0") : "";
    },
  },
  watch: {
    courseInfo(newValue) {
      if (!newValue) return;

      this.form.learnDuration = newValue.learnDuration;
      this.form.learnTimeLimit = newValue.learnTimeLimit;
    },
  },
};
</script>

<style lang="scss" scoped>
.management-section {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .title-section {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-text {
      display: flex;
      align-items: center;

      span {
        margin-bottom: 0;
      }
    }
  }

  .duration-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #cdcdcd;
    padding: 20px 30px;
  }
}
.trial-badge {
  color: #814e13;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 12px;
  margin-left: 10px;
  background-color: #fefcea;
  border: 1px solid #f4e4bd;
}
</style>
